export { resizableEditorComponent } from './resizable-editor.component'
